<template>
  <transition name="fadeup">
    <div :class="classObject" v-if="!notification.seen">
      <div class="c-notification-item__inner">
        <strong>{{notification.title}}</strong>
        <span v-html="' ' + notification.body"></span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'notification-item',

  props: {
    notification: Object,
    type: String,
  },

  computed: {
    classObject() {
      return {
        'c-notification-item': true,
        [`c-notification-item--${this.type}`]: this.type,
      };
    },
  },
};
</script>


<style lang="scss">
.c-notification-item {
  margin: 0.5em;

  display: block;
  pointer-events: none;

  &__inner {
    display: inline-block;
    width: auto;
    border-radius: 10em;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
    padding: 1em;
    background: $colour-nhs-white;
    pointer-events: auto;
  }

  &__title {
    //
  }

  &__body {
    //
  }

  &--success &__inner {
    background: #0cce4e;
    color: $colour-nhs-white;
  }

  &--danger &__inner {
    background: $colour-nhs-emergency-red;
    color: $colour-nhs-white;
  }
}

.fadeup-enter-active,
.fadeup-leave-active {
  transition: all 0.3s 0.3s;
}
.fadeup-enter {
  transform: translateY(40px);
  opacity: 0;
}
.fadeup-enter-to {
  transform: translateY(0);
  opacity: 1;
}

.fadeup-leave-to {
  transition: all 0.3s 0.3s;
  transform: translateY(40px);
  opacity: 0;
}
</style>

